
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    mixins: [],
})
export default class WidgetTemplate extends Mixins<MixinInterface>() {
    @Prop({ default: 'primary' }) color!: any
    @Prop({ required: true }) component!: any
    @Prop({ required: false }) dashboardId!: string
    @Prop({ required: true }) hasAccess!: boolean
    @Prop({ default: true, type: Boolean }) canDelete!: boolean

    get widgetAccessible() {
        return this.hasAccess || this.isSuperuser
    }

    get widget() {
        return this.$store.getters.widgetsData[this.component?.id]
    }

    get dashboard() {
        return this.dashboardId ? this.$store.getters.dashboard(this.dashboardId) : null
    }

    name = ''
    dialog = false

    toggleMenu(val) {
        this.dialog = val
        this.$emit('update:dialog', val)
    }

    saveWidget() {
        this.$emit('update:widget')
        const widgets = this.lodash.cloneDeep(this.$store.getters.widgetsData)
        const widget = widgets[this.component.id]

        if (widget?.name) {
            widget.name = this.name
        } else {
            this.$emit('update:name', this.name)
        }
        this.$store.commit('widgetsData', widgets)

        this.toggleMenu(false)
    }

    deleteWidget() {
        this.$store.commit('deleteWidget', this.component?.id)
        this.toggleMenu(false)
    }

    @Watch('dialog')
    setName() {
        this.name = this.widget?.name || this.component?.name || ''
    }
}
